import { atom } from 'recoil';

import { IS_SOUND } from '../constants';

export const AIsSound = atom<boolean>({
  key: IS_SOUND,
  default: true,
});
